const MIN_PASSWORD_LENGTH = 8;

export const rules = {
  notEmpty: {
    check: value => value && value.toString().trim().length > 0,
    msg: 'Validation.empty_field',
  },

  minLength: {
    check: (value, len = 1) => value && value.toString().trim().length >= len,
    msg: 'Validation.password_too_short',
  },

  matchString: {
    check: (value, toMatch) => value && value === toMatch,
    msg: 'Validation.confirm_pw_no_match',
  },

  isNumber: {
    check: value => value && /^\d+$/.test(value),
    msg: 'Validation.postal_code_not_number',
  },

  validEmail: {
    // regex matches for string to contain 'xxx@xxx.xxx'
    check: value => value && /^[^@]+@[^@]+\.[^@]+$/.test(value),
    msg: 'Validation.email',
  },

  isChecked: {
    // checkbox checked property should be passed in to this rule (eg. evt.target.checked)
    check: value => !!value,
    msg: 'Validation.terms_and_conditions',
  },
};

const validate = (type, value) => {
  const errors = [];
  const { validEmail, notEmpty, isNumber, minLength, matchString, isChecked } = rules;

  switch (type) {
  case 'email':
    if (!validEmail.check(value)) errors.push(validEmail.msg);
    break;
  case 'text':
    if (!notEmpty.check(value)) errors.push(notEmpty.msg);
    break;
  case 'postalCode':
    if (!isNumber.check(value)) errors.push(isNumber.msg);
    break;
  case 'newPassword':
  case 'password':
    if (!minLength.check(value, MIN_PASSWORD_LENGTH)) errors.push(minLength.msg);
    break;
  case 'confirmNewPassword':
  case 'confirmPassword':
    // If we are matching two values pass an array with both items as value
    if (!matchString.check(value[0], value[1])) errors.push(matchString.msg);
    break;
  case 'select':
    if (!notEmpty.check(value)) errors.push(notEmpty.msg);
    break;
  case 'termsAndConditions':
    if (!isChecked.check(value)) errors.push(isChecked.msg);
    break;
  default:
    break;
  }

  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/util/inputValidation.js